import React from "react";
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import '@fontsource/roboto';
import displayname from '../media/instruction/displayname.png'

const useStyles = theme => ({
  img:{
    maxWidth: '80%'
  },
  li:{
    paddingBottom: '10px'
  }
});


class End extends React.Component {

    
    render(){
      const { classes } = this.props;

      return (
          <div style={{padding: '40px', backgroundColor: 'white', paddingBottom: '100px'}}>
             <Typography variant='h5' className={classes.li}>
                Activity Ended 
              </Typography>
            <div style={{textAlign:'justify', marginBottom: '20px'}}>
              <Typography variant='body1' component={'ul'}>
                <li className={classes.li}>
                  Based on the pre-survey answers, we would like to inform that you are not our target participants. 
                </li>
                <li className={classes.li}>
                  We are recruiting participants who read the instruction thoroughly and participate with considerations. There were attention check questions in our pre-survey and it seems that your answers were not valid for the questions. 
                </li >
                <li className={classes.li}>
                 If you have any questions on why your answer was not considered as invalid answre, please feel free to contact the researcher below.
                  <ul>
                    <li>
                    Contact: eunyoungko@kaist.ac.kr
                    </li>
                  </ul>
                </li>
              </Typography>
            </div>
            </div> 
        );
  }
}

export default withStyles(useStyles)(End);
